"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gql = exports["default"] = void 0;

var _react = require("react");

var _api = _interopRequireWildcard(require("@aws-amplify/api"));

var _graphActions = require("../reducers/graphReducer/graphActions");

var _graphReducer = _interopRequireDefault(require("../reducers/graphReducer/graphReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var requests = {};
var keyCounts = {};
var blockedKeys = {};

var generateKey = function generateKey() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return JSON.stringify(args);
};

var doOperation = function doOperation(ql, vars) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      var key, timeBucket, operation, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = generateKey(ql, vars);

              if (!blockedKeys[key]) {
                _context.next = 4;
                break;
              }

              reject(new Error('API error detected, request blocked'));
              return _context.abrupt("return");

            case 4:
              timeBucket = "".concat(Math.floor(Date.now() / (1000 * 2)), "-").concat(key);
              keyCounts[timeBucket] = (keyCounts[timeBucket] || 0) + 1;

              if (!(keyCounts[timeBucket] > 10)) {
                _context.next = 11;
                break;
              }

              blockedKeys[key] = true;
              console.warn('API error detected, blocking request:', [ql, vars]);
              reject(new Error('API error detected, request blocked'));
              return _context.abrupt("return");

            case 11:
              if (!requests[key]) {
                _context.next = 15;
                break;
              }

              requests[key].handlers.push({
                resolve: resolve,
                reject: reject
              });
              _context.next = 28;
              break;

            case 15:
              requests[key] = {
                handlers: [{
                  resolve: resolve,
                  reject: reject
                }]
              };
              _context.prev = 16;
              operation = (0, _api.graphqlOperation)(ql, _objectSpread({}, vars));
              _context.next = 20;
              return _api["default"].graphql(operation);

            case 20:
              response = _context.sent;
              requests[key].handlers.forEach(function (_ref2) {
                var resolve = _ref2.resolve;
                return resolve(response);
              });
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](16);
              requests[key].handlers.forEach(function (_ref3) {
                var reject = _ref3.reject;
                return reject(_context.t0);
              });

            case 27:
              delete requests[key];

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 24]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var gql = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
    var projection, vars, resolverField, _yield$doOperation, rawData, _yield$doOperation$er, errors, data, _errors$0$message, error, message, _e$errors, _errors, _error;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            projection = _ref4.projection, vars = _ref4.vars, resolverField = _ref4.resolverField;
            _context2.prev = 1;
            _context2.next = 4;
            return doOperation(projection, vars);

          case 4:
            _yield$doOperation = _context2.sent;
            rawData = _yield$doOperation.data;
            _yield$doOperation$er = _yield$doOperation.errors;
            errors = _yield$doOperation$er === void 0 ? [] : _yield$doOperation$er;
            data = rawData === null || rawData === void 0 ? void 0 : rawData[resolverField];

            if (!(errors !== null && errors !== void 0 && errors.length)) {
              _context2.next = 14;
              break;
            }

            error = (_errors$0$message = errors[0].message) !== null && _errors$0$message !== void 0 ? _errors$0$message : 'The request failed, please try again';
            return _context2.abrupt("return", {
              error: error
            });

          case 14:
            return _context2.abrupt("return", {
              data: data
            });

          case 15:
            _context2.next = 26;
            break;

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](1);

            if (!(typeof _context2.t0 === 'string')) {
              _context2.next = 23;
              break;
            }

            return _context2.abrupt("return", {
              error: _context2.t0
            });

          case 23:
            message = _context2.t0.message, _e$errors = _context2.t0.errors, _errors = _e$errors === void 0 ? [] : _e$errors;
            _error = _errors !== null && _errors !== void 0 && _errors.length ? _errors[0].message : message;
            return _context2.abrupt("return", {
              error: _error
            });

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 17]]);
  }));

  return function gql(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.gql = gql;

var useGraph = function useGraph(_ref6) {
  var projection = _ref6.projection,
      resolverField = _ref6.resolverField;

  var _useReducer = (0, _react.useReducer)(_graphReducer["default"], {
    loading: false,
    data: undefined,
    error: undefined,
    complete: false
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var request = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var vars,
        abort,
        _yield$gql,
        data,
        error,
        _args3 = arguments;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            vars = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
            abort = _args3.length > 1 ? _args3[1] : undefined;
            dispatch({
              type: _graphActions.LOADING
            });
            _context3.next = 5;
            return gql({
              projection: projection,
              vars: vars,
              resolverField: resolverField
            });

          case 5:
            _yield$gql = _context3.sent;
            data = _yield$gql.data;
            error = _yield$gql.error;

            if (!(abort && abort())) {
              _context3.next = 11;
              break;
            }

            console.log('Ignoring aborted request response');
            return _context3.abrupt("return");

          case 11:
            if (error) {
              dispatch({
                type: _graphActions.ERROR,
                error: error
              });
            } else {
              dispatch({
                type: _graphActions.DATA,
                data: data
              });
            }

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [projection, resolverField]);
  return [state, {
    request: request
  }];
};

var _default = useGraph;
exports["default"] = _default;